import { immunityEffects } from '../configs/entities/effects';

import { ImmunityEffectKey, ImmunityEffectType } from './effect-types';

const immunityEntries = Object.entries(immunityEffects)
  .map(([key, { priority }]) => [key, priority] as const);

/**
 * Maps an immunity string to a priority integer.
 * both must be unique.
 */
export const immunityToPriority = Object.fromEntries(
  immunityEntries
) as { [key in ImmunityEffectKey]: ImmunityEffectType[key]['priority'] };

/**
 * Maps an priority integer to an immunity string.
 * both must be unique.
 */
export const priorityToImmunity = Object.fromEntries(
  immunityEntries.map(([key, priority]) => [priority, key])
) as { [key in ImmunityEffectKey as ImmunityEffectType[key]['priority']]: key };
